import component from './en-US/component';
import globalHeader from './en-US/globalHeader';
import menu from './en-US/menu';
import pages from './en-US/pages';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.copyright.produced': 'All Rights Reserved | ZPayment.io',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list': 'Quickly build standard, pages based on `block` development',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...component,
  ...pages,
  'page.dashboard.title': 'Dashboard',
  'page.notFound.title': '404',
  'page.notFound.subTitle': 'Sorry, the page you visited does not exist',
  'page.notFound.button': 'Return Home',
  'page.500.title': '500',
  'page.500.subTitle': 'Sorry, something went wrong! Please try again later.',
  'page.retry.button': 'Retry',
};
